import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';

import {
    Button, Link, Typography,
} from '@material-ui/core';

import {
    validateRequired, validateAllFields, validateFieldLecagy_TOBEREMOVED, checkHasErrors,
} from '../../youwell-common/validationUtils';

// import { UnreadIcon } from '../../common/icons';

import * as UserStore from '../../app/store/UserStore';
import { timestamp } from '../../youwell-common/dateUtils';
import { HtmlContent, Image, PollData } from '../../youwell-common/components';
import { FileUpload, PageLayout, PortalModal, TextEditor } from '../../common/components';
import { getBreadCrumb } from '../../common/breadcrumbUtil';
import apiUrls from '../../youwell-common/apiUrls';
import { fileTypes } from '../../youwell-common/constants';

const POLLING_INTERVAL_IN_MINUTES = 1;
const NUMBER_OF_MESSAGES_TO_LOAD = 20;

const styles = theme => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    list: {
        flex: '1 1 auto',
        height: '100%',
        overflow: 'auto',
        padding: theme.spacing(2),
    },
    actions: {
        marginTop: theme.spacing(2),
    },
    textInput: {
        background: theme.youwell.colors.inputBackground,
    },
    sendLine: {
        marginTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'flex-end',

        [theme.breakpoints.down('xs')]: {
            flexWrap: 'wrap',
        },
    },
    attachFile: {
        marginRight: theme.spacing(2),

        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
            marginBottom: theme.spacing(1),
            width: '100%',
        },
    },
    messageList: {

    },
    message: {
        marginBottom: theme.spacing(2),
    },
    textLine: {
        display: 'flex',
        alignItems: 'center',
    },
    lineFill: {
        flex: '1 0 20%',
    },
    textBox: {
        padding: theme.spacing(2),
        borderRadius: theme.youwell.shapes.borderRadius,
    },
    textarea: {
        height: 105,
        [theme.breakpoints.down('xs')]: {
            height: 55,
        },
    },
    fromPatient: {
        background: theme.youwell.colors.secondaryBackground,
        color: theme.palette.common.primary,
    },
    fromOther: {
        background: theme.youwell.colors.white,
        color: theme.youwell.colors.primary,
    },
    date: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
    },
    unreadIcon: {
        opacity: 0.54,
    },
    image: {
        width: '100%',
    },
    attachedFileButton: {
        textTransform: 'none',
        textDecoration: 'underline',
        borderRadius: 0,
    },
});

const defaultState = {
    text: '',
    attachmentFileId: '',
    showAttachedFile: null,
};

const validators = {
    text: validateRequired,
};

const createInitialState = () => ({
    ...defaultState,
    validationErrors: {},
});

class MessageList extends React.Component {
    state = createInitialState();

    componentDidMount() {
        this.markAsReadIfAny();
    }

    componentDidUpdate(prevProps) {
        if (this.props.messagesTimestamp !== prevProps.messagesTimestamp) {
            this.markAsReadIfAny();

            setTimeout(() => {
                document.getElementById('scrollList').scroll({
                    top: document.getElementById('scrollList').scrollHeight,
                    behavior: 'smooth',
                });
            }, 200);
        }
    }

    getMessagesInitial = () => {
        this.props.checkForNewMessages({
            requestParams: {
                count: NUMBER_OF_MESSAGES_TO_LOAD,
            },
        });
    }

    checkForMessages = () => {
        this.props.checkForNewMessages({
            background: true,
            requestParams: {
                timeStamp: this.props.messagesTimestamp,
            },
        });
    }

    fetchMoreMessages = () => {
        this.props.checkForNewMessages({
            requestParams: {
                start: this.props.messageList.length,
                count: NUMBER_OF_MESSAGES_TO_LOAD,
            },
        });
    }

    markAsReadIfAny = () => {
        if (this.props.messageList && this.props.messageList.filter(d => !d.patientReadTime).length > 0) {
            this.props.markMessagesAsRead(this.props.messagesTimestamp, {
                background: true,
                reducerParams: { timestamp: this.props.messagesTimestamp },
            });
        }
    }

    handleChange = name => (event) => {
        this.setState({ [name]: event.target.value }, () => {
            if (validators[name]) {
                const validationErrors = validateFieldLecagy_TOBEREMOVED(this.state, validators[name], name); // eslint-disable-line react/no-access-state-in-setstate
                this.setState({ validationErrors });
            }
        });
    }

    sendMessage = () => {
        const validationErrors = validateAllFields(this.state, validators);

        if (!checkHasErrors(validationErrors)) {
            const data = {
                patientId: this.props.profile.id,
                text: this.state.text,
                attachedFileId: this.state.attachmentFileId,
                checkTimeStamp: this.props.messagesTimestamp,
            };

            this.props.insertMessage(data, {
                callback: () => {
                    this.setState(createInitialState());
                },
            });
        } else {
            this.setState({ validationErrors });
        }
    }

    onSelectFile = (file) => {
        this.setState({ attachmentFileId: file?.id });
    }

    showAttachedFile = attachedFile => (event) => {
        if (attachedFile?.type === fileTypes.image) {
            this.setState({ showAttachedFile: attachedFile });
            event.preventDefault();
        } else {
            this.setState({ showAttachedFile: null });
        }
    }

    render() {
        const {
            classes, translate, messageList, profile, clientConfig, canLoadMoreMessages, appConfig,
        } = this.props;

        if (!profile) {
            return null;
        }

        return (
            <PageLayout
                title={translate('chat.heading')}
                breadcrumb={getBreadCrumb(translate('chat.heading'), translate, clientConfig)}
            >
                <PollData
                    initialdataCall={this.props.messageList ? this.checkForMessages : this.getMessagesInitial}
                    dataCall={this.checkForMessages}
                    pollingIntervalInMinutes={POLLING_INTERVAL_IN_MINUTES}
                />

                <div className={classes.actions}>
                    <Typography variant="caption">
                        {translate('chat.sendMessageToTherapist')}
                    </Typography>

                    <TextEditor
                        className={classes.textInput}
                        value={this.state.text}
                        onChange={this.handleChange('text')}
                    />

                    <div className={classes.sendLine}>
                        {clientConfig.appSetup.features.allowFileUpload && (
                            <FileUpload onSelected={this.onSelectFile} className={classes.attachFile} />
                        )}
                        <Button onClick={this.sendMessage} color="primary" variant="contained">
                            {translate('chat.send')}
                        </Button>
                    </div>
                </div>

                <div className={classes.list} id="scrollList">
                    <PortalModal allowZoom heading={translate(`filetypes.${this.state.showAttachedFile?.type}`)} open={!!this.state.showAttachedFile} onClose={this.showAttachedFile(null)}>
                        {this.state.showAttachedFile && (
                            <div className={classes.imageContainer}>
                                {this.state.showAttachedFile.type === fileTypes.image ? (
                                    <Image className={classes.image} src={`${apiUrls.baseUrl}/${apiUrls.app.media}/${this.state.showAttachedFile.id}`} />
                                ) : (
                                    <Link href={`${apiUrls.baseUrl}/${apiUrls.app.media}/${this.state.showAttachedFile.id}`} target="_blank">
                                        {translate('chat.downloadFile')}
                                    </Link>
                                )}
                            </div>
                        )}
                    </PortalModal>

                    {messageList?.map(item => (
                        <div key={item.created} className={classes.message}>
                            {item.attachedFileId && (
                                <Link
                                    underline="hover"
                                    target="_blank"
                                    rel="noopener"
                                    className={classes.attachedFileButtons}
                                    onClick={this.showAttachedFile({ id: item.attachedFileId, type: item.attachedFileType })}
                                    href={`${apiUrls.baseUrl}/${apiUrls.app.media}/${item.attachedFileId}?xAppId=${appConfig.appId}`}
                                >
                                    {`${translate('chat.attachedFile')}: ${translate(`filetypes.${item.attachedFileType}`)}`}
                                </Link>
                            )}

                            <div className={classes.textLine}>
                                {!item.senderIsPatient && (
                                    <>
                                        <div className={classes.lineFill} />
                                        <Typography variant="caption" className={classes.date} color="textSecondary">
                                            {timestamp(item.created)}
                                        </Typography>
                                    </>
                                )}

                                <HtmlContent html={item.text} className={classnames(classes.textBox, { [classes.fromPatient]: item.senderIsPatient, [classes.fromOther]: !item.senderIsPatient })} />

                                {item.senderIsPatient && (
                                    <React.Fragment>
                                        <Typography variant="caption" className={classes.date} color="textSecondary">
                                            {timestamp(item.created)}
                                        </Typography>
                                        <div className={classes.lineFill} />
                                    </React.Fragment>
                                )}
                            </div>

                            <Typography variant="caption" align={item.senderIsPatient ? 'left' : 'right'} color="textSecondary" display="block">
                                {item.senderIsPatient ? translate('chat.you') : item.senderName}
                            </Typography>
                        </div>
                    ))}
                </div>

                {canLoadMoreMessages && (
                    <Button onClick={this.fetchMoreMessages}>
                        {translate('chat.fetchOlderMessages')}
                    </Button>
                )}

            </PageLayout>
        );
    }
}

MessageList.propTypes = {
    classes: PropTypes.object.isRequired,
    clientConfig: PropTypes.object.isRequired,
    profile: PropTypes.object,
    translate: PropTypes.func.isRequired,
    checkForNewMessages: PropTypes.func.isRequired,
    markMessagesAsRead: PropTypes.func.isRequired,
    messageList: PropTypes.array,
    insertMessage: PropTypes.func.isRequired,
    messagesTimestamp: PropTypes.string,
    canLoadMoreMessages: PropTypes.bool.isRequired,
    appConfig: PropTypes.object.isRequired,
};

MessageList.defaultProps = {
    messageList: null,
    profile: null,
    messagesTimestamp: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    profile: state.auth.profileData,
    messageList: state.user.messageList,
    canLoadMoreMessages: !state.user.allMessagesFetched,
    clientConfig: state.auth.clientConfig,
    messagesTimestamp: state.user.messagesTimestamp,
    appConfig: state.pageSettings.appConfig,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(UserStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MessageList));
